// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller
/* eslint-disable */

import { application } from "../application"

import AjaxController from './ajax_controller.js'
application.register('ajax', AjaxController)

import AnimationController from './animation_controller.js'
application.register('animation', AnimationController)

import ApplicationController from './application_controller.js'
application.register('application', ApplicationController)

import AsyncRenderController from './async_render_controller.js'
application.register('async-render', AsyncRenderController)

import BreadcrumbsController from './breadcrumbs_controller.js'
application.register('breadcrumbs', BreadcrumbsController)

import ChecklistController from './checklist_controller.js'
application.register('checklist', ChecklistController)

import ClipboardController from './clipboard_controller.js'
application.register('clipboard', ClipboardController)

import ClickTrackerController from './click_tracker_controller.js'
application.register('click-tracker', ClickTrackerController)

import ContactPickerController from './contact_picker_controller.js'
application.register('contact-picker', ContactPickerController)

import CountdownController from './countdown_controller.js'
application.register('countdown', CountdownController)

import DragController from './drag_controller.js'
application.register('drag', DragController)

import ExpandableController from './expandable_controller.js'
application.register('expandable', ExpandableController)

import FilterSelectController from './filter_select_controller.js'
application.register('filter-select', FilterSelectController)

import FormController from './form_controller.js'
application.register('form', FormController)

import ImageZoomController from './image_zoom_controller.js'
application.register('image-zoom', ImageZoomController)

import IntersectorController from './intersector_controller.js'
application.register('intersector', IntersectorController)

import LegacyInvitationsController from './legacy/invitations_controller.js'
application.register('legacy--invitations', LegacyInvitationsController)

import PagarmeController from './pagarme_controller.js'
application.register('pagarme', PagarmeController)

import TunaController from './tuna_controller.js'
application.register('tuna', TunaController)

import PaypalController from './paypal_controller.js'
application.register('paypal', PaypalController)

import PhotoEditorController from './photo_editor_controller.js'
application.register('photo-editor', PhotoEditorController)

import ResizerController from './resizer_controller.js'
application.register('resizer', ResizerController)

import ScrollerController from './scroller_controller.js'
application.register('scroller', ScrollerController)

import SetoutEditorController from './setout/editor_controller.js'
application.register('setout--editor', SetoutEditorController)

import SetoutValidatorController from './setout/validator_controller.js'
application.register('setout--validator', SetoutValidatorController)

import SetoutFragmentController from './setout/fragment_controller.js'
application.register('setout--fragment', SetoutFragmentController)

import ShareController from './share_controller.js'
application.register('share', ShareController)

import SliderController from './slider_controller.js'
application.register('slider', SliderController)

import SlideshowController from './slideshow_controller.js'
application.register('slideshow', SlideshowController)

import SuggestionsController from './suggestions_controller.js'
application.register('suggestions', SuggestionsController)

import TimeController from './time_controller.js'
application.register('time', TimeController)

import TimeUntilController from './time_until_controller.js'
application.register('time-until', TimeUntilController)

import UtilController from './util_controller.js'
application.register('util', UtilController)

import WithdrawalController from './withdrawal_controller.js'
application.register('withdrawal', WithdrawalController)

import GalleryController from './gallery_controller.js'
application.register('gallery', GalleryController)

import ImageTransitionController from './image_transition_controller'
application.register('image-transition', ImageTransitionController)

import WhatsappController from './whatsapp_controller'
application.register('whatsapp', WhatsappController)

import VideoController from './video_controller'
application.register('video', VideoController)

import CheckboxController from './checkbox_controller'
application.register('checkbox', CheckboxController)
